import { render, staticRenderFns } from "./PrintTag.vue?vue&type=template&id=768d7815&scoped=true"
import script from "./PrintTag.vue?vue&type=script&lang=js"
export * from "./PrintTag.vue?vue&type=script&lang=js"
import style0 from "./PrintTag.vue?vue&type=style&index=0&id=768d7815&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768d7815",
  null
  
)

export default component.exports